import React, {useEffect, useState} from 'react';
import useStore from "../zustand/useStore";
import {actionToGetNewsDataByCategoryFilter} from "../apiHelpers/CommonAction";
import {FacebookLoader} from "./Loader/FacebookLoader";
import {IonIcon} from "@ionic/react";
import {bookmark, bookmarkOutline} from "ionicons/icons";

export default function NewsFilterTabs({newsCategory}) {
    const {selectedNewsCategory,setSelectedNewsCategory} = useStore();
    const {loading,categoryData} = newsCategory;
    const [isBookMarkFilterActive, setIsBookMarkFilterActive] = useState(false);

    const callFunctionToGetCategoryData = (category)=>{
        setIsBookMarkFilterActive(false);
        setSelectedNewsCategory(category);
        actionToGetNewsDataByCategoryFilter(category,false);
    }

    useEffect(()=>{
        if(categoryData?.length) {
            callFunctionToGetCategoryData(categoryData[0]?.category);
        }
    },[categoryData])

    const handleBookMarkFilter = () => {
        setIsBookMarkFilterActive(!isBookMarkFilterActive);
        actionToGetNewsDataByCategoryFilter('All',true);
    }

    return (
        <>
            {(loading) ?
                <FacebookLoader type={"facebookStyle"} item={2}/>
                :
                <div className="news-tabs">
                    <button
                        onClick={() => handleBookMarkFilter()}
                        className={`tab ${isBookMarkFilterActive ? 'active' : ''}`}>
                        <IonIcon icon={isBookMarkFilterActive ? bookmark : bookmarkOutline} slot="start"/>
                    </button>
                    {(categoryData?.map(({category}) => (
                        <button key={category} onClick={() => callFunctionToGetCategoryData(category)}
                                className={`tab ${!isBookMarkFilterActive && category === selectedNewsCategory ? 'active' : ''}`}>
                            {category && category?.replace(/-/g, " ").replace(/\b\w/g, l => l.toUpperCase())}
                        </button>
                    )))}
                </div>
            }

        </>
    );
}
